import db from "@/database";

export const CONSENT_FILE_ID = "fixed";

export const getConsentFile = () => {
  return db.settings.get(CONSENT_FILE_ID);
};
